import { useContext, useRef, useEffect, useCallback, useState } from 'react'
import { ProjectContext } from './provider'

export const useProject = () => {
  return useContext(ProjectContext)
}

export const useDelayedLoading = (
  initialValue: boolean = false,
): [boolean, (value: boolean) => void] => {
  const [loading, setLoadingState] = useState(initialValue)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const setLoading = useCallback((value: boolean) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    if (value) {
      // true の場合は即時にセット
      setLoadingState(true)
    } else {
      // false の場合は 0.05 秒遅延してセット
      timeoutRef.current = setTimeout(() => {
        setLoadingState(false)
      }, 50)
    }
  }, [])

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  return [loading, setLoading]
}
